import $ from 'jquery';
import 'jquery.mmenu';
$(document).ready(function( $ ){
  $('#wow-menu__navmobile').mmenu({
    extensions: ["position-right"],
    scrollBugFix: {
      fix: false
    }
  });
});